export default __webpack_public_path__ + "static/media/image5.558ac4b2.jpg";